<button
  (click)="click()"
  [class.button-large]="size === 'large'"
  [class.button-medium]="size === 'medium'"
  [class.button-small]="size === 'small'"
  [class.button-xs]="size === 'xs'"
  [disabled]="_disabled"
  [ngClass]="cssClass"
  [ngStyle]="inlineStyle"
  [style.background-color]="backgroundColor"
  [style.border-color]="borderColor"
  [style.color]="color"
  [style.height]="height"
  [style.width]="width"
  [type]="type"
  class="button"
  role="button"
>
  @if (isLoading || currentState.type === StateType.Loading) {
    <app-icon iconName="spinner" marginRight="10px" size="22px"></app-icon>
    {{ currentState?.title }}
  }
  @if (!isLoading && currentState.type !== StateType.Loading) {
    @if (prefixIconName) {
      <span
        class="placement-{{ iconPlacement }}"
        [style.top]="iconPositionTop"
        [style.right]="iconPositionRight"
        [style.bottom]="iconPositionBottom"
        [style.left]="iconPositionLeft"
        [ngStyle]="iconInlineStyle"
      >
        <app-icon [color]="iconColor" [cssStyle]="{ marginRight: '8px' }" [iconName]="prefixIconName" [size]="iconSize" planeIcon="true"></app-icon>
      </span>
    }
    {{ currentState?.title }}
    @if (postfixIconName) {
      <span
        class="placement-{{ iconPlacement }}"
        [style.top]="iconPositionTop"
        [style.right]="iconPositionRight"
        [style.bottom]="iconPositionBottom"
        [style.left]="iconPositionLeft"
        [ngStyle]="iconInlineStyle"
      >
        <app-icon [color]="iconColor" [cssStyle]="{ marginLeft: '8px', marginBottom: '2px' }" [iconName]="postfixIconName" [size]="iconSize" planeIcon="true"></app-icon>
      </span>
    }
  }
</button>
